import React, { useState, useRef, useEffect } from 'react'
import logoImage from '../img/logo.svg'
import { GiHamburgerMenu } from 'react-icons/gi'
import { AiOutlineClose } from 'react-icons/ai'
import { IoIosArrowBack } from 'react-icons/io'

const Nav = () => {
    const [showNav, setShowNav] = useState(false)
    const [showFormation, setShowFormation] = useState(false)
    const navRef = useRef()

    useEffect(() => {
        function handleEscapeKey(event) {
            if (event.code === 'Escape') {
                setShowNav(false)
            }

        }

        const handleEscapeClick = (event) => {
            if (!navRef?.current?.contains(event.target)) {
                // console.log(event.target)
                setShowNav(false)
            }
        }

        document.addEventListener('keydown', handleEscapeKey)
        document.addEventListener('mousedown', handleEscapeClick)
        return () => {
            document.removeEventListener('keydown', handleEscapeKey)
            document.removeEventListener('mousedown', handleEscapeClick)
            setShowFormation(false)
        }
    }, [])

    const handleToggle = (event) => {
        showFormation ? setShowFormation(false) : setShowFormation(true)
        // console.log(showFormation)

    }

    return (
        <div className=' sticky top-0 bg-white z-50'>
            <nav className='flex justify-between items-center mx-5 xl:mx-20'>
                <ul className=' hidden xl:flex xl:justify-between xl:items-center xl:text-[22px] xl:w-[70%]'>
                    <li className=' cursor-pointer'>
                        <img src={logoImage} alt="" className=' w-[200px] object-contain' />
                    </li>
                    <li className='hover:text-[#fe8200] cursor-pointer'><a href="#" >Services</a></li>
                    <div className='group inline-block '>
                        <button className=' outline-none focus:outline-none px-3 py-1 bg-white rounded-sm flex items-center min-w-32'>
                            <span className=' pr-1 flex-1 '>Solutions</span>
                            <span>
                                <svg
                                    className="fill-current h-8 w-8 transform group-hover:-rotate-180 transition duration-300 ease-in-out"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20">
                                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                </svg>
                            </span>
                        </button>
                        <ul className="bg-white min-w-[300px] min-h-[180px] shadow-lg pl-[40px] py-[25px] z-1 border rounded-lg transform scale-0 group-hover:scale-100 absolute 
transition duration-150 ease-in-out origin-top text-gray-500">
                            <li><a className='hover:text-[#fe8200] cursor-pointer inline-block py-[7px]' href="">Market entry</a></li>
                            <li><a className='hover:text-[#fe8200] cursor-pointer inline-block py-[7px]' href="">Operational Support</a></li>
                            <li><a className='hover:text-[#fe8200] cursor-pointer inline-block py-[7px]' href="">Starting up</a></li>
                        </ul>
                    </div>
                    <div className='group inline-block '>
                        <button className=' outline-none focus:outline-none px-3 py-1 bg-white rounded-sm flex items-center min-w-32'>
                            <span className=' pr-1 flex-1 '>Resources</span>
                            <span>
                                <svg
                                    className="fill-current h-8 w-8 transform group-hover:-rotate-180 transition duration-300 ease-in-out"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20">
                                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                </svg>
                            </span>
                        </button>
                        <ul className="bg-white min-w-[300px] min-h-[180px] shadow-lg pl-[40px] py-[25px] z-1 border rounded-lg transform scale-0 group-hover:scale-100 absolute 
transition duration-150 ease-in-out origin-top text-gray-500">
                            <li><a className='hover:text-[#fe8200] cursor-pointer inline-block py-[7px]' href="">Guides</a></li>
                            <li><a className='hover:text-[#fe8200] cursor-pointer inline-block py-[7px]' href="">Client stories</a></li>
                            <li><a className='hover:text-[#fe8200] cursor-pointer inline-block py-[7px]' href="">Downloads</a></li>
                        </ul>
                    </div>
                    <li className='hover:text-[#fe8200] cursor-pointer'><a href="#" >About us</a></li>
                    <li className='hover:text-[#fe8200] cursor-pointer'><a href="#" >News & insights</a></li>
                </ul>
                <ul className='hidden xl:flex xl:items-center xl:w-[30%] xl:justify-end'>
                    <li className='mr-10'>
                        <button className=' min-w-[130px] h-[42px] rounded-full text-[#fe8200] border-[#fe8200] border-[3px] px-8  transition delay-100 ease-in hover:bg-[#fe8200] hover:text-white'>Contact us</button>
                    </li>
                    <li className=' cursor-pointer'><img src="https://img.freepik.com/free-vector/illustration-thailand-flag_53876-27145.jpg" alt="Thailand" className='w-[50px] h-[50px] rounded-full object-fill object-center' /></li>
                </ul>
                <ul className=' float-left xl:hidden'>
                    <li className=' cursor-pointer'>
                        <img src={logoImage} alt="" className=' w-[200px] object-contain' />
                    </li>
                </ul>
                <ul className='float-right xl:hidden'>
                    <li>
                        <GiHamburgerMenu size={30} className=' cursor-pointer transition hover:scale-110 ease-in-out duration-150' onClick={() => setShowNav(true)} />
                    </li>
                </ul>

            </nav>
            {showNav &&
                <div className='fixed w-[100vw] inset-0 bg-black bg-opacity-25 backdrop-blur-sm m-0 right-0 top-0 z-100 overflow-scroll pb-20 xl:hidden'>
                    <div ref={navRef} className='w-[60%] min-w-[300px] min-h-[100vh] bg-white float-right scroll-smooth'>
                        <div className='relative float-right pt-[10px] pr-[10px] '>
                            <AiOutlineClose className='cursor-pointer text-3xl text-gray-500 transition hover:text-black hover:rotate-180 delay-300 duration-200 ease-in-out ' size={25} onClick={() => setShowNav(false)} />


                        </div>
                        <div className='w-full font-semibold  '>
                            <ul className=' text-xl mt-[50px] ml-[30px] space-y-4'>
                                <li className='' >

                                    <div href="" className=' cursor-pointer w-full' onClick={(e) => handleToggle(e)} >
                                        <span className=' float-left mb-4'>Formation</span>
                                        <span className=' float-right'>
                                            {
                                                showFormation ?
                                                    <svg
                                                        className="fill-current h-8 w-8 transform transition duration-500 ease-in-out "
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 20 20">
                                                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                                    </svg>
                                                    :
                                                    <svg
                                                        className="fill-current h-8 w-8 transform -rotate-180 transition duration-500 ease-in-out"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 20 20">
                                                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                                    </svg>

                                            }
                                        </span>
                                    </div>
                                    {showFormation ?
                                        <ul className='clear-both transition duration-1000 ease-in-out text-gray-500 space-y-4 lg:hidden'>
                                            <li ><a className='hover:text-black ' href="">Company register</a></li>
                                            <li className='space-y-4'>
                                                <a className='hover:text-black' href="">Business structures</a>
                                                <ul className='ml-4 space-y-4'>
                                                    <li><a className='hover:text-black' href="">Limited company</a></li>
                                                    <li><a className='hover:text-black' href="">BOI company</a></li>
                                                    <li><a className='hover:text-black' href="">US Treaty of Amity company</a></li>
                                                    <li><a className='hover:text-black' href="">Representative office</a></li>
                                                    <li><a className='hover:text-black' href="">Brach office</a></li>
                                                    <li><a className='hover:text-black' href="">Regional operation HQ</a></li>
                                                    <li><a className='hover:text-black' href="">Non-profit foundation</a></li>
                                                    <li><a className='hover:text-black' href="">Registered address</a></li>
                                                    <li><a className='hover:text-black' href="">Virtual office address</a></li>
                                                </ul>
                                            </li>
                                        </ul>
                                        :
                                        <div></div>
                                    }
                                </li>
                                <li className='clear-both'><a href="" className=' hover:text-gray-500'>Corporate governance</a></li>
                                <li><a href="" className='hover:text-gray-500'>Accounting & tax</a></li>
                                <li><a href="" className='hover:text-gray-500'>HR outsourcing</a></li>
                                <li><a href="" className='hover:text-gray-500'>Immigration & visa</a></li>
                                <li><a href="" className='hover:text-gray-500'>Legal</a></li>
                                <li><a href="" className='hover:text-gray-500'>Solutions</a></li>
                                <li><a href="" className='hover:text-gray-500'>Resources</a></li>
                                <li><a href="" className='hover:text-gray-500'>About us</a></li>
                            </ul>
                            <div className='text-xl my-[50px] ml-[30px]'>
                                <p className=' font-mono text-lg'>Call us today</p>
                                <p className=' font-bold text-2xl'>+123-456-7890</p>
                                <button className='mt-[10px] rounded-full text-[#fe8200] border-[#fe8200] border-[3px] py-3 px-8 text-xl  transition delay-100 ease-in hover:bg-[#fe8200] hover:text-white'>Contact us</button>

                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>

    )
}

export default Nav